import React, { FC } from 'react';

const IconCalendarioTarjeta: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      {...props}
    >
      <title>Icon / calendario</title>
      <g id="Icon-_x2F_-calendario">
        <g id="Group-3">
          <g />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter"
              filterUnits="userSpaceOnUse"
              x="0.5"
              y="0.5"
              width="23"
              height="23"
            >
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
              />
            </filter>
          </defs>
          <mask
            maskUnits="userSpaceOnUse"
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            id="mask-2"
          >
            <g filter="url(#Adobe_OpacityMaskFilter)">
              <polygon
                id="path-1"
                fill="#FFFFFF"
                points="0.5,0.5 23.5,0.5 23.5,23.5 0.5,23.5 				"
              />
            </g>
          </mask>
          <path
            id="Fill-1"
            mask="url(#mask-2)"
            d="M17.051,4.821h1.427c0.413,0,0.731-0.336,0.731-0.728V1.235
                        c0-0.402-0.318-0.735-0.731-0.735h-1.427c-0.409,0-0.744,0.333-0.744,0.735v2.858C16.306,4.484,16.641,4.821,17.051,4.821
                        L17.051,4.821z M22.077,9.139c0-2.767-16.193-1.458-18.683-1.458c-0.805,0-1.465,0.656-1.465,1.458v11.465
                        c0,0.806,0.66,1.432,1.465,1.432h17.253c0.807,0,1.43-0.617,1.43-1.432V9.139z M23.5,6.242v14.361c0,1.57-1.276,2.896-2.853,2.896
                        H3.394C1.78,23.5,0.5,22.174,0.5,20.604V6.242c0-1.569,1.28-2.845,2.895-2.845h0.693v0.696c0,0.803,0.673,1.469,1.438,1.469h1.465
                        c0.767,0,1.438-0.666,1.438-1.469V3.397h7.185v0.696c0,0.803,0.63,1.469,1.438,1.469h1.427c0.808,0,1.429-0.666,1.429-1.469V3.397
                        h0.741C22.223,3.397,23.5,4.673,23.5,6.242L23.5,6.242z M5.526,4.821h1.465c0.405,0,0.696-0.336,0.696-0.728V1.235
                        c0-0.402-0.291-0.735-0.696-0.735H5.526c-0.37,0-0.694,0.333-0.694,0.735v2.858C4.832,4.484,5.156,4.821,5.526,4.821L5.526,4.821z
                        M6.11,9.734c1.215,0,2.171,0.995,2.171,2.156c0,1.213-0.956,2.152-2.171,2.152c-1.164,0-2.156-0.939-2.156-2.152
                        C3.954,10.729,4.946,9.734,6.11,9.734L6.11,9.734z M12.347,9.734c1.179,0,2.171,0.995,2.171,2.156
                        c0,1.213-0.992,2.152-2.171,2.152c-1.214,0-2.167-0.939-2.167-2.152C10.18,10.729,11.134,9.734,12.347,9.734L12.347,9.734z
                        M18.552,9.734c1.219,0,2.16,0.995,2.16,2.156c0,1.213-0.941,2.152-2.16,2.152c-1.178,0-2.175-0.939-2.175-2.152
                        C16.378,10.729,17.375,9.734,18.552,9.734L18.552,9.734z M6.11,15.328c1.215,0,2.171,0.957,2.171,2.166
                        c0,1.176-0.956,2.152-2.171,2.152c-1.164,0-2.156-0.977-2.156-2.152C3.954,16.285,4.946,15.328,6.11,15.328L6.11,15.328z
                        M12.347,15.328c1.179,0,2.171,0.957,2.171,2.166c0,1.176-0.992,2.152-2.171,2.152c-1.214,0-2.167-0.977-2.167-2.152
                        C10.18,16.285,11.134,15.328,12.347,15.328L12.347,15.328z M18.552,15.328c1.219,0,2.16,0.957,2.16,2.166
                        c0,1.176-0.941,2.152-2.16,2.152c-1.178,0-2.175-0.977-2.175-2.152C16.378,16.285,17.375,15.328,18.552,15.328L18.552,15.328z"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconCalendarioTarjeta;
